import { RouteConfig } from 'vue-router'

export const sellerTermsRoutes: RouteConfig[] = [
  {
    path: '/seller-terms',
    name: 'sellerTerms',
    component: () =>
      import(
        /* webpackChunkName: "TheSellerTermsChunk" */ '@/modules/term-and-conditions/seller-terms/views/TheSellerTerms.vue'
      ),
    meta: {
      title: 'navigations.termAndConditionsSellerMetaTitle',
      parentRouteName: null
    }
  },
  {
    path: '/seller-terms/preview-details/:id',
    name: 'preview-sellerTerms',
    component: () =>
      import(
        /* webpackChunkName: "ThePreviewSellerTermsChunk" */ '@/modules/term-and-conditions/seller-terms/views/ThePreviewSellerTerms.vue'
      ),
    meta: {
      title: 'navigations.termAndConditionsSellerMetaTitle',
      parentRouteName: 'sellerTerms'
    }
  },
  {
    path: '/seller-terms/upsert',
    name: 'upsert-sellerTerms',
    component: () =>
      import(
        /* webpackChunkName: "TheUpsertSellerTermsChunk" */ '@/modules/term-and-conditions/seller-terms/views/TheUpsertSellerTerms.vue'
      ),
    meta: {
      title: 'navigations.termAndConditionsSellerMetaTitle',
      parentRouteName: 'sellerTerms'
    }
  }
]
